import React from 'react';
import './Logo.css';


const Logo = (props) => {
    return (
        <div onClick={props.logoLink} className="LogoFrame" style={{backgroundColor: props.trialBackgroundColor}} />
    )
}

export default Logo;